import React, {useState} from "react";
import type { BraillerInventoryItemDto } from '../../brailler.types';
import {Button} from "../../../../../Components/Inputs";
import {GridCell, GridTable} from "../../../../../Components/Grid";
import {emptyBraillerInventoryItemModel} from "./braillerInventoryItemFactory";
import {BraillerInventoryRow} from "./BraillerInventoryRow";
import * as PolicyEvents from "../../../../../Components/Authorize/policyEventsConstants";
import {allow} from "../../../../../Components/Authorize";
import {BraillerInventoryEditRow} from "./BraillerInventoryEditRow";
import {getBraillerInventoryItemId} from "./braillerInventoryUtility";

export const BraillerInventoryView = ({
                                          inventoryItems = [],
                                          onInventoryChange,
                                          catalogItemId,
                                          title,
                                      }: {
    inventoryItems?: BraillerInventoryItemDto[];
    onInventoryChange: (items: BraillerInventoryItemDto[]) => void;
    catalogItemId: string;
    title?: string;
}) => {

    const [editingIndex, setEditingIndex] = useState(-1);
    const canManageCatalog = allow(PolicyEvents.MANAGE_BRAILLER_CATALOG);

    const braillerInventoryItems = Array.isArray(inventoryItems) ? inventoryItems : [];

    const resetEditingIndex = () => setEditingIndex(-1);

    const handleEditInventoryItem = (index: number) => setEditingIndex(index);

    const handleDeleteInventoryItem = (index: number) => {
        const inventoryItemsAfterDeletion = braillerInventoryItems.filter((_item: BraillerInventoryItemDto, currentIndex: number) => currentIndex !== index);
        onInventoryChange(inventoryItemsAfterDeletion);
    };

    const handleSaveInventoryItem = (updatedInventoryItem: Record<string, any>, index: number) => {
        if (canManageCatalog) {
            const updatedItems = braillerInventoryItems.map((inventoryItem: BraillerInventoryItemDto, currentIndex: number) =>
                currentIndex === index ? updatedInventoryItem as BraillerInventoryItemDto : inventoryItem
            );
            onInventoryChange(updatedItems);
        }
        resetEditingIndex();
    };

    const handleCancelEditingInventoryItem = () => resetEditingIndex();

    const handleClickAddInventoryItem = () => {
        const emptyBraillerInventoryItem = {...emptyBraillerInventoryItemModel};
        emptyBraillerInventoryItem.braillerCatalogItemId = catalogItemId;

        const updatedItems = [...braillerInventoryItems, emptyBraillerInventoryItem];
        const newIndex = updatedItems.length - 1;
        onInventoryChange(updatedItems);

        setEditingIndex(newIndex);
    };

    const titleText = title ? `${title} - Inventory Items` : 'Inventory Items';

    return (
        <div>
            <h3>
                {titleText} ({braillerInventoryItems.length})
            </h3>
            <p>Manage the individual brailler items.</p>

            {
                braillerInventoryItems.length > 0 &&
                <GridTable className="searchResults">
                    <thead>
                    <tr>
                        <th>Serial Number</th>
                        <th>Status</th>
                        <th>Notes</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                    braillerInventoryItems.map((braillerInventoryItem: BraillerInventoryItemDto, index: number) => {

                            const braillerInventoryItemId = getBraillerInventoryItemId(braillerInventoryItem, index);

                            return editingIndex === index ?
                                <BraillerInventoryEditRow
                                    key={braillerInventoryItemId}
                                    index={index}
                                    canManageCatalog={canManageCatalog}
                                    braillerInventoryItem={braillerInventoryItem}
                                    handleSaveInventoryItem={handleSaveInventoryItem}
                                    handleCancelInventoryItem={handleCancelEditingInventoryItem}/>
                                :
                                <BraillerInventoryRow
                                    key={braillerInventoryItemId}
                                    index={index}
                                    braillerInventoryItem={braillerInventoryItem}
                                    handleEditInventoryItem={handleEditInventoryItem}
                                    handleDeleteInventoryItem={handleDeleteInventoryItem}
                                />;
                        })
                    }
                    </tbody>
                </GridTable>
            }

            <GridCell className="text-center">
                <Button
                    name="btnAddItem"
                    label="Add Item"
                    onClick={handleClickAddInventoryItem}
                    isPrimary
                />
            </GridCell>
            {
                braillerInventoryItems.length === 0 &&
                <p className="text-center">No items added yet. Click &quot;Add Item&quot; to add the first item.</p>
            }
        </div>
    );
};

